import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import useCartStore from './cart'
import useConsultStore from './consult'
import useDistributionStore from './distribution'
import useOrderStore from './order'
import useUserStore from './user'

export * from './commonStore'
export { useCartStore, useConsultStore, useDistributionStore, useOrderStore, useUserStore }

const stores = createPinia()
stores.use(piniaPluginPersistedstate)

export default stores
